var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCtaBg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 1920,
  height: 420,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 1564.96,
  height: 1247.71,
  x: 1075.09,
  y: -910.376,
  fill: "#fff",
  fillOpacity: 0.08,
  rx: 50,
  transform: "rotate(45.905 1075.09 -910.376)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 1290.38,
  height: 961.472,
  x: -245.481,
  y: -442,
  fill: "#fff",
  fillOpacity: 0.08,
  rx: 50,
  transform: "rotate(45.905 -245.481 -442)"
})));
export { SvgCtaBg as ReactComponent };
export default __webpack_public_path__ + "0ee82c50b1af24c6da58e90e1da08791.svg";